const common_message_id = {
    delete_msg_title: "Apakah anda yakin?",
    delete_msg_text: "Data yang dihapus tidak dapat dipulihkan.",

    posting_msg_title: "Apakah anda yakin untuk memposting data ini?",
    posting_msg_text: "Data yang sudah di posting tidak dapat diubah kembali.",

    error: {
        posting: "Gagal memposting data, silahkan coba lagi.",
    },

    success: {
        posting: "Berhasil memposting data.",
    },
}

export default common_message_id;